// import * as fromReducer from '../reducers';
import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import {PaymentStreamSetting} from '../../../models/payment-stream-setting.model';
import {StreamsState} from '../reducers/streams.reducer';

export const getStreamsState = createFeatureSelector<StreamsState>(
  'streams'
);

export const getStreams: MemoizedSelector<object,  PaymentStreamSetting[]> = createSelector(
  getStreamsState,
  (state: StreamsState) => state.streams
);
